module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid38_980x877.c6a807e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid38_980x877.jpg
// module id = tL+5
// module chunks = 0